export default function useHasUnpaidBalance(unpaidBalance?: number): boolean {
  return unpaidBalance !== undefined && unpaidBalance > 0;
}
